import { Image, Page, Text, View } from '@react-pdf/renderer';
import { useQuotePdfContext } from '@ui/pages/QuoteBuilder/hooks';
import { styles } from '@ui/pdfs/styles';

import { TermsAndConditions } from './components/TermsAndConditions';
import { CustomerQuotePdfTemplate } from './template';

export function CustomerQuote() {
  const { quoteId } = useQuotePdfContext();
  return (
    <Page size="A4" style={styles.page}>
      <View style={styles.row}>
        <View style={[styles.section, styles.alignCenter]}>
          <Image
            src={'/images/ADF/ADDISON_FASTENERS_RGB_PRIMARY_LOGO_AW.png'}
            style={styles.logo}
          />
        </View>
        <View style={styles.section}>
          <Text style={styles.bold}>Addison Fasteners</Text>
          <Text>196 N. Addison Rd. </Text>
          <Text>Addison, IL 60101</Text>
          <Text>Phone (847) 229-1999</Text>
        </View>
        <View style={[styles.section, styles.alignCenter, styles.maxWidthFull]}>
          <Text style={[styles.quoteNumber, styles.bold]}>
            Quotation {quoteId}
          </Text>
          <Text style={styles.textSmall}>
            Please refer to the quotation number when ordering
          </Text>
        </View>
      </View>
      <CustomerQuotePdfTemplate showPartDescription={true} showFOB={true} />
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={styles.bold}>COMMENTS:</Text>
          <Text style={styles.textSmall}>
            Please advise the certification you require at the time of order.
            This will be billed as a separate line on each line level & will be
            sent with the shipment unless otherwise specified.
          </Text>
          <Text style={styles.textSmall}>
            PKG 1 - Certification of Compliance
          </Text>
          <Text style={styles.textSmall}>
            PKG 2 - Full Certification with Material and Subcontractors Certs
            $240.00
          </Text>
          <Text style={styles.textSmall}>
            PKG 3 - Full Certification with Material and Subcontractors Certs
            plus Dimensional Layout $275.00
          </Text>
          <Text style={styles.textSmall}>
            PKG 4 - Standard PPAP Level I - $50
          </Text>
          <Text style={styles.textSmall}>
            PKG 5 - Customer Specific PPAP Level III - $550
          </Text>
          <Text style={styles.textSmall}>
            PLEASE SEND ALL PURCHASE ORDERS TO addisonsales@mwcomponents.com
          </Text>
          <Text style={styles.textSmall}>
            Quoted lead-time is subject to change based on capacity at the time
            of purchase order receipt.
          </Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={styles.bold}>DELIVERY:</Text>
          <Text style={styles.textSmall}>
            View Your Order Status & Tracking Online:
          </Text>
          <Text style={styles.textSmall}>
            For updates on your order status and tracking information, log in to
            your account on MWComponents.com using the same email address
            associated with your order. Navigate to My Account, then select
            Orders. If you do not already have an account, you can create one.
            Orders associated with the account email address will automatically
            populate.
          </Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={styles.bold}>TERMS AND CONDITIONS OF SALE</Text>
          <TermsAndConditions style={[styles.textSmall]} />
        </View>
      </View>
    </Page>
  );
}
